import LabelCard from "./LabelCard";
import { LabelData } from "../../StaticData/LabelData";
import "./Label.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import axiosInstance from "../../config/axios-instance";

export interface ILabelListProps {
  width: number;
  labelsData: any[];
}

export default function LabelList({ width, labelsData }: ILabelListProps) {

  return (
    <div className="label_container">
      <div className="label_title">
        {width >= 768 && <div className="blue_line"></div>}
        <h2 className="our_label">Our labels</h2>
      </div>
      
      {/* Infinite Marquee Loop */}
      <div className="label_marquee_wrapper">
        <div className="label_marquee_track">
          {/* Original Set */}
          {labelsData?.map((label: any, i: any) => (
             <div key={`orig-${i}`} style={{ margin: "0 20px" }}>
               <LabelCard label={label} />
             </div>
          ))}
          {/* Duplicate Set for seamless loop */}
          {labelsData?.map((label: any, i: any) => (
             <div key={`dup-${i}`} style={{ margin: "0 20px" }}>
               <LabelCard label={label} />
             </div>
          ))}
          {/* Triplicate Set for wide screens */}
          {labelsData?.map((label: any, i: any) => (
             <div key={`trip-${i}`} style={{ margin: "0 20px" }}>
               <LabelCard label={label} />
             </div>
          ))}
        </div>
      </div>
    </div>
  );
}
